import { ref, watch } from 'vue';
import lodash from 'lodash';

export class State {

    stateDefinition;

    currentValue;

    constructor(name, stateDefinition) {
        this.stateDefinition = stateDefinition;
        this.currentValue = ref(lodash.cloneDeep(stateDefinition.defaultValue));
        if (this.stateDefinition.localStorage !== false) {
            if (localStorage.getItem(this.stateDefinition.localStorage) === null) {
                localStorage.setItem(stateDefinition.localStorage, JSON.stringify(this.currentValue.value));
            } else {
                this.currentValue.value = JSON.parse(localStorage.getItem(this.stateDefinition.localStorage));
            }
            window.addEventListener('storage', () => {
                this.currentValue.value = JSON.parse(localStorage.getItem(this.stateDefinition.localStorage));
            });
        }

        watch(this.currentValue, () => {
            if (this.stateDefinition.localStorage === false) {
                return;
            }
            if (localStorage.getItem(this.stateDefinition.localStorage) === JSON.stringify(this.currentValue.value)) {
                return;
            }
            localStorage.setItem(this.stateDefinition.localStorage, JSON.stringify(this.currentValue.value));
        }, {
            deep: true,
        });
    }

    get data() {
        return this.currentValue.value;
    }

    set data(val) {
        this.currentValue.value = val;
    }

    watch(callback, options = {}) {
        watch(this.currentValue, callback, options);
    }

    reset() {
        this.currentValue.value = this.stateDefinition.default;
    }
}
